import { css } from "styled-components";
import token from "styled-token";
import { spaceMixin } from "../spaceMixin";
import { ButtonMixin } from "./ButtonMixin";
import { iconSizeMixin } from "../iconSizeMixin";
import { BUTTON_SHAPES } from "../../constants";

var SquareIconButton = function SquareIconButton(props) {
  var size = props.size;
  return token({
    size: "sizes.heights." + size
  }, function (tokens) {
    return css(["", " height:", "px;width:", "px;display:flex;align-items:center;justify-content:center;padding:", ";&[aria-pressed=\"true\"]:disabled{opacity:1;}"], ButtonMixin, tokens.size, tokens.size, spaceMixin(size === "xs" ? "xs" : "sm")(props));
  });
};

var CircleIconButton = function CircleIconButton() {
  return token({
    radius: "radii.ellipse"
  }, function (tokens) {
    return css(["", " border-radius:", ";"], SquareIconButton, tokens.radius);
  });
};
/** @class IconButtonMixin */

/** @method */


export var IconButtonMixin = function IconButtonMixin(props) {
  var appearance = props.appearance,
      size = props.size;
  return css(["", ";span{", "}"], appearance === BUTTON_SHAPES.circle ? CircleIconButton : SquareIconButton, iconSizeMixin(Object.assign({}, props, {
    iconSize: size === "xs" || size === "sm" ? "xs" : "sm"
  })));
};